export const usePwaUpdateStore = defineStore('pwaUpdate', {
  state: () => ({
    status: 'unknown',
    currentBuild: null,
    available: false,
    unsupported: false,
    dismissed: false,
    updating: false,
    error: false,
    checkFailed: false,
    loadFailed: false,
    destination: null,
    pendingDestination: null,
  }),
})
